const selectors = {
  selectSaleItem: 'Chọn Đơn hàng Bán{{mode}}',
  multiple: ' (Nhiều)',
  single: ' (Đơn)',
};

export default selectors;